import clsx from "clsx";

/** The Klarity mark in white and orange, for a dark ground: the rail and the sign-in panel. */
export function KlarityMark({ className = "h-7.5 w-6" }: { className?: string }) {
  return (
    <svg viewBox="300 132 242 302" className={clsx("shrink-0", className)} aria-hidden="true">
      <polygon
        className="fill-white"
        points="402.9912 309.5985 483.1426 424.9371 534.4323 424.9371 432.8174 279.8833 402.9912 309.5985"
      />
      <polygon
        className="fill-white"
        points="532.9425 139.7837 476.3779 139.7837 350.7215 273.3178 350.7227 273.1815 307.4575 316.4467 307.4575 319.2941 307.4575 380.4554 307.4575 424.9371 351.0926 424.9371 351.0926 334.0849 533.467 140.2773 532.9425 139.7837"
      />
      <polygon
        className="fill-orange"
        points="382.435 206.7724 351.2168 164.9698 324.0399 198.2693 353.3778 237.6516 382.435 206.7724"
      />
    </svg>
  );
}
